<template>
  <v-app>

    <v-main>
      <router-view />

    </v-main>

  </v-app>
</template>

<script>
import { useMainStore } from '@/stores';
import isOnline from '@/helpers/online';

export default {
   name: "App",

  watch: {
    // Language switched: a post offline in the new language gets the choice page;
    // on the choice page, a post that is online in the new language is opened.
    '$i18n.locale'(locale){
      const onChoice = this.$route.name === 'offline-choice';
      const name = onChoice ? this.$route.query.post : this.$route.name;
      if (!name) return;
      if (isOnline(name, locale)) {
        if (onChoice && this.$router.options.routes.some(r => r.name === name)) {
          this.$router.replace({ name }).catch(() => {});
        }
      } else if (!onChoice) {
        this.$router.replace({ name: 'offline-choice', query: { post: name } }).catch(() => {});
      }
    }
  },

  mounted(){
    window.setTimeout(()=>{
      const stores = useMainStore();
      stores.setLoading(false)
      //this.$store.commit('SET_LOADING', false);
    }, 500);
  }
};
</script>


<style>
  @import './assets/main.css';
</style>

